var placeholderImg2 = "/static/627e767899671704.png";

export { placeholderImg2 as default };
//# sourceMappingURL=placeholder-2.png.js.map
